import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTokenUserData } from '@data/hooks';
import { useOnboardingsStore } from '@data/storage';

export const useTrialOnboarding = () => {
  const { userId } = useTokenUserData();
  const { trialId = '' } = useParams<{ trialId: string }>();
  const { onboardings = {}, setDefaultOnboardingTrial } = useOnboardingsStore();

  useEffect(() => {
    // Set default onboarding trial if it doesn't exist
    if (onboardings[userId] && !onboardings[userId]?.trials[trialId]) {
      setDefaultOnboardingTrial(userId, trialId);
    }
  }, []);
};
